"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ImpressionRecorder = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InView = _interopRequireDefault(require("./InView"));

var _Metadata = _interopRequireWildcard(require("./Metadata"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _excluded = ["type", "correlate", "msBeforeTrack"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ImpressionContext = /*#__PURE__*/_react["default"].createContext({
  record: function record() {
    // eslint-disable-next-line no-console
    console.warn('attempted to record an impression without a parent ImpressionContext');
  },
  identify: _noop["default"]
});

var TrackedImpression = function TrackedImpression(_ref) {
  var type = _ref.type,
      correlate = _ref.correlate,
      msBeforeTrackOverride = _ref.msBeforeTrack,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useMetadata = (0, _Metadata.useMetadata)(),
      _useMetadata2 = (0, _slicedToArray2["default"])(_useMetadata, 1),
      getMetadata = _useMetadata2[0];

  var identity = (0, _react.useRef)();
  var tracked = (0, _react.useRef)(false);
  var trackedTimer = (0, _react.useRef)();

  var _useContext = (0, _react.useContext)(ImpressionContext),
      record = _useContext.record,
      identify = _useContext.identify,
      msBeforeTrackContext = _useContext.msBeforeTrack;

  var msBeforeTrack = (0, _isUndefined["default"])(msBeforeTrackOverride) ? msBeforeTrackContext : msBeforeTrackOverride;
  var onViewableChange = (0, _react.useCallback)(function (inView) {
    if (tracked.current) {
      return;
    }

    var exec = function exec() {
      tracked.current = true;
      var metadata = getMetadata();

      if (correlate) {
        if (!identity.current) {
          identity.current = identify();
        }

        metadata = _objectSpread(_objectSpread({}, metadata), {}, {
          id: identity.current
        });
      }

      record(metadata, type);
    };

    if (msBeforeTrack) {
      clearTimeout(trackedTimer.current);

      if (inView) {
        trackedTimer.current = setTimeout(exec, msBeforeTrack);
      }
    } else {
      if (inView) {
        exec();
      }
    }
  }, [type, correlate, getMetadata, record]);
  var onMetadataRequest = (0, _react.useCallback)(function () {
    if (!identity.current) {
      identity.current = identify();
    }

    return {
      correlationId: identity.current
    };
  }, []);

  var child = /*#__PURE__*/_react["default"].createElement(_InView["default"], (0, _extends2["default"])({}, rest, {
    onChange: onViewableChange
  }));

  if (correlate) {
    return /*#__PURE__*/_react["default"].createElement(_Metadata["default"], {
      value: onMetadataRequest
    }, child);
  }

  return child;
};

TrackedImpression.propTypes = {
  msBeforeTrack: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool]),
  correlate: _propTypes["default"].bool,
  type: _propTypes["default"].string
};

var ImpressionRecorder = function ImpressionRecorder(_ref2) {
  var children = _ref2.children,
      onRecord = _ref2.onRecord,
      onIdentify = _ref2.onIdentify,
      msBeforeTrack = _ref2.msBeforeTrack;
  var value = (0, _react.useMemo)(function () {
    return {
      record: onRecord,
      identify: onIdentify || _noop["default"],
      msBeforeTrack: msBeforeTrack
    };
  }, [onRecord, msBeforeTrack]);
  return /*#__PURE__*/_react["default"].createElement(ImpressionContext.Provider, {
    value: value
  }, children);
};

exports.ImpressionRecorder = ImpressionRecorder;
ImpressionRecorder.propTypes = {
  msBeforeTrack: _propTypes["default"].number,
  children: _propTypes["default"].any.isRequired,
  onRecord: _propTypes["default"].func.isRequired,
  onIdentify: _propTypes["default"].func
};
var _default = TrackedImpression;
exports["default"] = _default;